import { render, staticRenderFns } from "./OrganizationStructure.vue?vue&type=template&id=3158fc10&scoped=true&"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js&"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158fc10",
  null
  
)

export default component.exports